export default class Modals {
	constructor()
	{
		let isAfterAJAX = false;

		const send = XMLHttpRequest.prototype.send
		XMLHttpRequest.prototype.send = function() {
			this.addEventListener('load', function() {
				let isAfterAJAX = true;
				if(isAfterAJAX === true) {
					setTimeout(() => {
						const annualReports = document.getElementsByClassName("block-annual-reports");
						if(annualReports.length) {
							this.modalOpeners = document.querySelectorAll("[data-modal]");
							this.modalClose   = document.querySelectorAll(".modal__close");
							this.videos       = document.querySelectorAll('iframe');

							// FOREACH MODAL BUTTON, TRACK CLICK
							this.modalOpeners && this.modalOpeners.forEach((button) => {
								button.addEventListener("click", (event) => {
									event.preventDefault();
									button.nextElementSibling.classList.add('modal--open');
								})
							});

							this.modalClose && this.modalClose.forEach((closer) => {
								closer.addEventListener("click", () => {
									this.videos.forEach(i => {
										const source = i.src
										i.src = ''
										i.src = source
									});

									let modal = closer.parentNode.parentNode;
									modal.classList.remove('modal--open');
								})
							});
						} else {
							this.modalOpeners = document.querySelectorAll("[data-modal]");
							this.modalClose   = document.querySelectorAll(".modal__close");
							this.videos       = document.querySelectorAll('iframe');

							// FOREACH MODAL BUTTON, TRACK CLICK
							this.modalOpeners && this.modalOpeners.forEach((button) => {
								button.addEventListener("click", (event) => {
									event.preventDefault();
									let modal = document.querySelector('.modal[data-modal-id="'+button.getAttribute('data-modal-id')+'"]');
									modal.classList.toggle('modal--open');
								})
							});

							this.modalClose && this.modalClose.forEach((closer) => {
								closer.addEventListener("click", () => {
									this.videos.forEach(i => {
										const source = i.src
										i.src = ''
										i.src = source
									})

									let modal = closer.parentNode.parentNode;
									modal.classList.remove('modal--open');
								})
							});
						}
					}, "100");
				}
			})
			return send.apply(this, arguments)
		}

		if(isAfterAJAX === false) {
			const annualReports = document.getElementsByClassName("block-annual-reports");
			if(annualReports.length) {
				this.modalOpeners = document.querySelectorAll("[data-modal]");
				this.modalClose   = document.querySelectorAll(".modal__close");
				this.videos       = document.querySelectorAll('iframe');

				// FOREACH MODAL BUTTON, TRACK CLICK
				this.modalOpeners && this.modalOpeners.forEach((button) => {
					button.addEventListener("click", (event) => {
						event.preventDefault();
						button.nextElementSibling.classList.add('modal--open');
					})
				});

				this.modalClose && this.modalClose.forEach((closer) => {
					closer.addEventListener("click", () => {
						this.videos.forEach(i => {
							const source = i.src
							i.src = ''
							i.src = source
						});

						let modal = closer.parentNode.parentNode;
						modal.classList.remove('modal--open');
					})
				});
			} else {
				this.modalOpeners = document.querySelectorAll("[data-modal]");
				this.modalClose   = document.querySelectorAll(".modal__close");
				this.videos       = document.querySelectorAll('iframe');

				// FOREACH MODAL BUTTON, TRACK CLICK
				this.modalOpeners && this.modalOpeners.forEach((button) => {
					button.addEventListener("click", (event) => {
						event.preventDefault();
						let modal = document.querySelector('.modal[data-modal-id="'+button.getAttribute('data-modal-id')+'"]');
						modal.classList.toggle('modal--open');
					})
				});

				this.modalClose && this.modalClose.forEach((closer) => {
					closer.addEventListener("click", () => {
						this.videos.forEach(i => {
							const source = i.src
							i.src = ''
							i.src = source
						})

						let modal = closer.parentNode.parentNode;
						modal.classList.remove('modal--open');
					})
				});
			}
		}
	}
}